import { ClockCircleOutlined, DashboardOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { FC } from "react";
import "./index.css";

interface PersonalBoardDetailCard {
  content: string;
  created_at: number;
  due_time?: number;
  title?: string;
  updated_at: number;
}

interface PersonalBoardDetailModalProps {
  card: PersonalBoardDetailCard | null;
  countdown?: {
    label: string;
    state: "normal" | "warning" | "overdue";
  } | null;
  onClose: () => void;
  onImageClick: (src: string) => void;
}

function formatBoardDate(value?: number, includeTime = false) {
  if (!value) {
    return "未设置";
  }
  return new Intl.DateTimeFormat("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    ...(includeTime
      ? { hour: "2-digit", minute: "2-digit", hour12: false }
      : {}),
  }).format(new Date(value));
}

const PersonalBoardDetailModal: FC<PersonalBoardDetailModalProps> = ({
  card,
  countdown,
  onClose,
  onImageClick,
}) => {
  function handleContentClick(event: React.MouseEvent<HTMLDivElement>) {
    const target = event.target as HTMLElement;
    if (target.tagName.toLowerCase() !== "img") {
      return;
    }
    const src = (target as HTMLImageElement).src;
    if (src) {
      onImageClick(src);
    }
  }

  return (
    <Modal
      centered
      className="personalBoardDetailModal"
      destroyOnClose
      footer={null}
      keyboard={false}
      maskClosable={false}
      onCancel={onClose}
      open={!!card}
      title={
        <div className="personalBoardDetailModal__title">
          <DashboardOutlined />
          <div>
            <strong>{card?.title || "看板卡片详情"}</strong>
            <span>个人看板卡片</span>
          </div>
        </div>
      }
      width={920}
    >
      {card && (
        <div className="personalBoardDetailModal__body">
          <div className="personalBoardDetailModal__meta">
            <div>
              <span>预期结束时间</span>
              <strong>{formatBoardDate(card.due_time)}</strong>
            </div>
            <div>
              <span>创建时间</span>
              <strong>{formatBoardDate(card.created_at, true)}</strong>
            </div>
            <div>
              <span>最近更新</span>
              <strong>{formatBoardDate(card.updated_at, true)}</strong>
            </div>
            {countdown && (
              <div
                className={`personalBoardDetailModal__countdown personalBoardDetailModal__countdown--${countdown.state}`}
              >
                <span>当前倒计时</span>
                <strong>
                  <ClockCircleOutlined />
                  {countdown.label}
                </strong>
              </div>
            )}
          </div>
          <section className="personalBoardDetailModal__section">
            <span>卡片内容</span>
            <div
              className="personalBoardDetailModal__content"
              dangerouslySetInnerHTML={{ __html: card.content }}
              onClick={handleContentClick}
            />
          </section>
        </div>
      )}
    </Modal>
  );
};

export default PersonalBoardDetailModal;
